"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Card_1 = require("components/base/Card");
const Layout_1 = require("components/base/Layout");
const Text_1 = __importDefault(require("components/base/Text"));
const BlogPostChangelog_1 = __importDefault(require("components/blog/BlogPostChangelog"));
const CSRFContext_1 = require("contexts/CSRFContext");
const Date_1 = require("utils/Date");
const Pagination_1 = __importDefault(require("../base/Pagination"));
const PAGE_SIZE = 18;
const CubeHistory = ({ changes, lastKey }) => {
    const { csrfFetch } = (0, react_1.useContext)(CSRFContext_1.CSRFContext);
    const [items, setItems] = (0, react_1.useState)(changes);
    const [currentLastKey, setLastKey] = (0, react_1.useState)(lastKey);
    const [page, setPage] = react_1.default.useState(0);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const pageCount = Math.ceil(items.length / PAGE_SIZE);
    const hasMore = !!currentLastKey;
    const evens = (0, react_1.useMemo)(() => {
        return items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).filter((_, index) => index % 2 === 0);
    }, [items, page]);
    const odds = (0, react_1.useMemo)(() => {
        return items.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).filter((_, index) => index % 2 !== 0);
    }, [items, page]);
    const fetchMoreData = (0, react_1.useCallback)(async () => {
        setLoading(true);
        const response = await csrfFetch(`/cube/getmorechangelogs`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                cubeId: items[0].cubeId,
                lastKey: currentLastKey,
            }),
        });
        if (response.ok) {
            const json = await response.json();
            if (json.success === 'true') {
                setItems([...items, ...json.posts]);
                setPage(page + 1);
                setLastKey(json.lastKey);
            }
        }
        setLoading(false);
    }, [currentLastKey, items, page]);
    const pager = (react_1.default.createElement(Pagination_1.default, { count: pageCount, active: page, hasMore: hasMore, onClick: async (newPage) => {
            console.log(newPage, pageCount);
            if (newPage >= pageCount) {
                await fetchMoreData();
            }
            else {
                setPage(newPage);
            }
        }, loading: loading }));
    return (react_1.default.createElement(Layout_1.Flexbox, { direction: "col", gap: "2", className: "my-2" },
        react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "between", alignItems: "center", className: "w-full" },
            react_1.default.createElement(Text_1.default, { lg: true, semibold: true },
                "Changes (",
                items.length,
                hasMore ? '+' : '',
                ")"),
            pager),
        react_1.default.createElement("div", { className: "block sm:hidden" }, items.length > 0 ? (items.map((changelog) => (react_1.default.createElement(Card_1.Card, { className: "my-2", key: changelog.date },
            react_1.default.createElement("div", { style: { overflow: 'auto', maxHeight: '20vh' } },
                react_1.default.createElement(Card_1.CardBody, null,
                    react_1.default.createElement(BlogPostChangelog_1.default, { changelog: changelog.changelog }))))))) : (react_1.default.createElement("p", null, "This cube has no history!"))),
        react_1.default.createElement("div", { className: "hidden sm:block" },
            react_1.default.createElement(Layout_1.Row, { className: "g-0 m-0 p-0" },
                react_1.default.createElement(Layout_1.Col, { xs: 6, className: "pe-4" }, items.length > 0 ? (evens.map((changelog) => (react_1.default.createElement(Card_1.Card, { className: "my-2", key: changelog.date },
                    react_1.default.createElement(Card_1.CardHeader, { className: "text-right" },
                        react_1.default.createElement(Text_1.default, { semibold: true, sm: true }, (0, Date_1.formatDateTime)(new Date(changelog.date)))),
                    react_1.default.createElement("div", { style: { overflow: 'auto', height: '15vh' } },
                        react_1.default.createElement(Card_1.CardBody, null,
                            react_1.default.createElement(BlogPostChangelog_1.default, { changelog: changelog.changelog }))))))) : (react_1.default.createElement("p", null, "This cube has no history!"))),
                react_1.default.createElement(Layout_1.Col, { xs: 6, className: "pl-4" },
                    react_1.default.createElement("div", { style: { height: '8vh' } }),
                    odds.map((changelog) => (react_1.default.createElement(Card_1.Card, { className: "my-2", key: changelog.date },
                        react_1.default.createElement(Card_1.CardHeader, null,
                            react_1.default.createElement(Text_1.default, { semibold: true, sm: true }, (0, Date_1.formatDateTime)(new Date(changelog.date)))),
                        react_1.default.createElement("div", { style: { overflow: 'auto', height: '15vh' } },
                            react_1.default.createElement(Card_1.CardBody, null,
                                react_1.default.createElement(BlogPostChangelog_1.default, { changelog: changelog.changelog }))))))))),
        ' ',
        react_1.default.createElement(Layout_1.Flexbox, { direction: "row", justify: "end", alignItems: "center", className: "w-full" }, pager)));
};
exports.default = CubeHistory;
